import BaseStore from 'fluxible/addons/BaseStore';

class ApplicationStore extends BaseStore {

  constructor(dispatcher) {
    super(dispatcher);
    this.flags = {};
    this.pageTitle = '';
    this.pageDescription = '';
    this.domainUrlApp = '';
    this.domainUrlDocs = '';
    this.domainUrlSignup = '';
  }

  isFramedMode() {
    return !!this.flags.framed;
  }

  isSingleQuickstartMode() {
    return !!this.flags.singleQuickstart;
  }

  getPageTitle() {
    return this.pageTitle;
  }

  getPageDescription() {
    return this.pageDescription;
  }

  getDomainUrlApp() {
    return this.domainUrlApp;
  }

  getDomainUrlSignup() {
    return this.domainUrlSignup;
  }

  getDomainUrlDocs() {
    return this.domainUrlDocs;
  }

  handleModeFlagsLoaded(payload) {
    this.flags = payload.flags;
    this.emitChange();
  }

  handlePageMetadata(payload) {
    this.pageTitle = payload.pageTitle;
    this.pageDescription = payload.pageDescription;
    this.emitChange();
  }

  handleEnvVariablesLoaded(payload) {
    this.domainUrlApp = payload.domainUrlApp;
    this.domainUrlDocs = payload.domainUrlDocs;
    this.domainUrlSignup = payload.domainUrlSignup;

    this.emitChange();
  }

  dehydrate() {
    return {
      flags: this.flags,
      pageTitle: this.pageTitle,
      pageDescription: this.pageDescription,
      domainUrlApp: this.domainUrlApp,
      domainUrlDocs: this.domainUrlDocs,
      domainUrlSignup: this.domainUrlSignup
    };
  }

  rehydrate(state) {
    this.flags = state.flags;
    this.pageTitle = state.pageTitle;
    this.pageDescription = state.pageDescription;
    this.domainUrlApp = state.domainUrlApp;
    this.domainUrlDocs = state.domainUrlDocs;
    this.domainUrlSignup = state.domainUrlSignup;
  }

}

ApplicationStore.storeName = 'ApplicationStore';
ApplicationStore.handlers = {
  MODE_FLAGS_LOADED: 'handleModeFlagsLoaded',
  UPDATE_PAGE_METADATA: 'handlePageMetadata',
  LOAD_ENV_VARIABLES: 'handleEnvVariablesLoaded'
};

export default ApplicationStore;
